<template>
  <ul class="flex flex-col gap-1 mt-3">
    <li
      class="bg-[#E5E5E533] gap-3 text-[14px] sm:text-[15px] md:text-[15.6px] 3xl:text-[16px] rounded-[5px] py-1 px-3 md:px-4 lg:px-5 flex justify-between items-center flex-nowrap"
      v-for="(ratingItem, index) in newRatingList"
      :key="index"
    >
      <!-- full rating -->
      <span class="flex flex-nowrap gap-1 items-center w-[5%]">
        {{arabizeNumbers( Number(ratingItem.id).toLocaleString() )}}
        <img
          :src="starIcon"
          alt
          width="15"
          height="15"
          class="w-[15px] object-contain"
        />
      </span>
      <!-- percentage progress bar -->
      <div class="w-[88%] flex justify-center">
        <div
          class="bg-[#E5E5E5] rounded-[18px] overflow-hidden w-full h-[12px] md:h-[13px] mx-auto"
        >
        
          <div :style="{width: `${Math.round(ratingItem.rate) || 0}%`}" :class="`h-full transition-[width] duration-500 ease-linear bg-primary`"></div>
        </div>
      </div>

      <!-- percentage number -->
      <strong class="w-[7%]">{{ $t('general.percentage_label', {percentage: arabizeNumbers(Math.round(Math.abs(Number(ratingItem.rate) || 0) * 10) / 10) }) }}</strong>
    </li>
  </ul>
</template>

<script>
import starIcon from "@/assets/images/star.svg";
import { arabizeNumbers } from "@/helpers";

export default {
  data() {
    return {
      starIcon
    };
  },
  props: {
    ratingsList: {
      type: [Object, null],
      required: true,
      default: () => ({})
    },
    maxStars: {
      type: Number,
      required: true,
      default: 5
    },
  },
  computed: {
    newRatingList() {
      return Array.from({ length: this.maxStars })
        .map((_, index) => {
          const newIndex = index + 1;
          const rate =
            (this.ratingsList && Object.keys(this.ratingsList || {}) && newIndex in this.ratingsList) ? this.ratingsList[newIndex] : null;
          return { id: newIndex, rate };
        })
        .reverse();
    }
  },
  methods: {
    arabizeNumbers,
  },
};
</script>

<style>
</style>